<template>

<app-page>

	<core-filter-bar v-if="!is.loading && is.initialised">

		<core-filter-bar-left>

			<core-filter-summary title="Feature Voting" icon="check-to-slot" />

		</core-filter-bar-left>

		<core-filter-bar-right>

			<core-button text="Patreon" href="https://patreon.com/geekgroup" class="tipjar-button" icon="arrow-up-right-from-square" theme="filter" />

		</core-filter-bar-right>

	</core-filter-bar>

	<core-content-page>

		<core-content-wrapper :loading="is.loading && !is.initialised">

			<div class="voting" :class="{'is-hidden': is.loading && !is.initialised}">

                <div class="voting-info" v-if="window.is.mobile">

                    <div class="voting-you">

                        <a href="https://patreon.com/geekgroup" target="_blank" class="voting-you-item is-dark" v-if="!isPatreon">

                            <div class="voting-you-item-value">Become a Patreon</div>
                            <div class="voting-you-item-label">Click to open</div>

                        </a>

                        <div class="voting-you-item is-red" v-if="remaining && $loggedin">

                            <div class="voting-you-item-value">{{ remaining }}</div>
                            <div class="voting-you-item-label">Vote<template v-if="remaining > 1">s</template> remaining</div>

                        </div>

                        <div class="voting-you-item is-green" v-if="!remaining && $loggedin && isPatreon">

                            <div class="voting-you-item-value"><i class="fa fa-check" /></div>
                            <div class="voting-you-item-label">Your votes cast</div>

                        </div>

                        <div class="voting-you-item" v-if="!isFinished">

                            <div class="voting-you-item-value">{{ countdown }}</div>
                            <div class="voting-you-item-label">{{ deadlinePeriod }} left to vote</div>

                        </div>

                        <div class="voting-you-item is-red" v-if="isFinished">

                            <div class="voting-you-item-value"><i class="fa fa-lock" /></div>
                            <div class="voting-you-item-label">Voting closed</div>

                        </div>

                    </div>

                    <div class="voting-about">

                        <p>Each month, patreons get to vote on which features should be built or improved next. Your votes help decide where development time goes - it could be a new insights page, more collection filters, or something completely experimental.</p>

                    </div>

                </div>

                <div class="voting-list">

                    <com-tabs :tabs="tabs" :active="tab" v-on:change="onTabChange" />

                    <template v-if="tab !== 'details'">

                        <div class="voting-list-empty" v-if="!features.length">There have been no winners yet.</div>

                        <com-item :item="item" v-for="item in features" :key="item.id" :count="counts[item.id]" :remaining="remaining" :finished="isFinished" :archived="isViewingWinners" v-on:up="onUpVote(item)" v-on:down="onDownVote(item)" />

                    </template>

                    <div class="voting-about is-details" v-if="tab === 'details'">

                        <ul>
                            <li>Voting is from 1st - 24th of each month.</li>
                            <li>Vote counts are not reavealed until voting closes.</li>
                            <li>The highest voted features will enter development - how many depends on time needed and complexity.</li>
                            <li>Higher-tier patreons get more votes and can vote on multiple features if desired.</li>
                            <li>Votes are reset each month and do not carry to the next.</li>
                            <li>Features may be added or removed to the list before new voting round starts.</li>
                            <li>Use the BGG Guild or E-mail to suggest new features.</li>
                        </ul>

                    </div>

                </div>

                <div class="voting-info" v-if="!window.is.mobile">

                    <div class="voting-you">

                        <a href="https://patreon.com/geekgroup" target="_blank" class="voting-you-item is-dark" v-if="!isPatreon">

                            <div class="voting-you-item-value">Become a Patreon</div>
                            <div class="voting-you-item-label">Click to open</div>

                        </a>

                        <div class="voting-you-item is-red" v-if="remaining && $loggedin">

                            <div class="voting-you-item-value">{{ remaining }}</div>
                            <div class="voting-you-item-label">Vote<template v-if="remaining > 1">s</template> remaining</div>

                        </div>

                        <div class="voting-you-item is-green" v-if="!remaining && $loggedin && isPatreon">

                            <div class="voting-you-item-value"><i class="fa fa-check" /></div>
                            <div class="voting-you-item-label">Your votes cast</div>

                        </div>

                        <div class="voting-you-item" v-if="!isFinished">

                            <div class="voting-you-item-value">{{ countdown }}</div>
                            <div class="voting-you-item-label">{{ deadlinePeriod }} left to vote</div>

                        </div>

                        <div class="voting-you-item is-red" v-if="isFinished">

                            <div class="voting-you-item-value"><i class="fa fa-lock" /></div>
                            <div class="voting-you-item-label">Voting closed</div>

                        </div>

                    </div>

                    <div class="voting-about">

                        <p>Each month, patreons get to vote on which features should be built or improved next. Your votes help decide where development time goes - it could be a new insights page, more collection filters, or something completely experimental.</p>

                    </div>

                    <div class="voting-about">

                        <ul>
                            <li>Voting is from 1st - 24th of each month.</li>
                            <li>Vote counts are not reavealed until voting closes.</li>
                            <li>The highest voted features will enter development - how many depends on time needed and complexity.</li>
                            <li>Higher-tier patreons get more votes and can vote on multiple features if desired.</li>
                            <li>Votes are reset each month and do not carry to the next.</li>
                            <li>Features may be added or removed to the list before new voting round starts.</li>
                            <li>Use the BGG Guild or E-mail to suggest new features.</li>
                        </ul>

                    </div>

                </div>

            </div>

		</core-content-wrapper>

	</core-content-page>
		
</app-page>

</template>

<script>

import Vue from 'vue'

import comTabs from './../profile/insights/common/Tabs'
import comItem from './voting/Item'

export default {

	components: {
		'com-tabs': comTabs,
        'com-item': comItem
	},

	data: function() {
	
		return {

			data: {},

            timer: false,

			is: {
				initialised: false,
				loading: true
			},

            tab: 'voting'

		}
	
	},

	created: function() {

		this.load()

	},

    computed: {

        isPatreon: function() {

            return (this.$loggedin) ? this.$store.getters['session/patreon'] : false

        },

        tabs: function() {

            var tabs = [
                { value: 'voting', text: (this.isFinished) ? this.data.month + ' Results' : this.data.month + ' Voting' },
                { value: 'winners', text: 'Past Winners', count: this.winnerCount },
            ]

            if (this.window.is.mobile) {

                tabs.push({ value: 'details', text: 'More details' })

            }

            return tabs

        },

        isFinished: function() {

            return this.difference < 0

        },

        winnerCount: function() {

            return this.$_.filter(this.data.voting, function(item) {

                return item.status === 2

            }.bind(this)).lentgh

        },

        difference: function() {

            return this.data.deadline - this.$moment().unix()

        },

        countdown: function() {

            var difference = 0

            if (this.difference < 3600) {

                difference = Math.ceil(this.difference / 60)

            } else if (this.difference < 86400) {

                difference = Math.ceil(this.difference / 3600)

            } else {

                difference = Math.ceil(this.difference / 86400)

            }

            return difference

        },

        deadlinePeriod: function() {

            var difference = 'Days'

            if (this.difference < 3600) {

                difference = 'Minutes'

            } else if (this.difference < 86400) {

                difference = 'Hours'

            } 

            return difference

        },

        remaining: function() {

            return this.data.limit - this.votes

        },

        votes: function() {

            var count = 0

            this.$_.each(this.data.votes, function(value) {

                count += value

            })

            return count 

        },

        counts: function() {

            return this.data.votes

        },

        isViewingWinners: function() {

            return this.tab === 'winners'

        },

        features: function() {

            var status = 1

            var sort = (this.isFinished) ? 'percent' : 'name'

            if (this.isViewingWinners) {
                
                status = 2
                sort = 'date'

            }

            var features = this.$_.sortBy(this.$_.filter(this.data.voting, function(item) {

                return item.status === status

            }.bind(this)), sort)

            if (this.isViewingWinners || this.isFinished) features = features.reverse()

            return features

        }

    },

	methods: {

        delayedSave: function() {

            clearTimeout(this.timer)

            this.timer = this.$_.delay(this.save, 500)

        },

        save: function() {

            this.$api.post('community/voting', {
                votes: this.data.votes
            }).then(function(json) {

				Vue.set(this.data, 'votes', json.votes)
			
			}.bind(this))

        },
	
		load: function() {
		
			this.$api.get('community/voting').then(function(json) {

				Vue.set(this, 'data', json)

                if(this.$_.isArray(this.data.votes)) this.data.votes = {}

				this.is.initialised = true

				this.is.loading = false
			
			}.bind(this))
		
		},

        onUpVote: function(item) {

            if(!this.data.votes[item.id]) Vue.set(this.data.votes, item.id, 0)

            this.data.votes[item.id] += 1

            this.delayedSave()

        },

        onDownVote: function(item) {

            this.data.votes[item.id] -= 1

            this.delayedSave()

        },

		onTabChange: function(value) {

			this.tab = value

		}

	}

}

</script>

<style scoped>

.voting {
    display: grid;
    grid-template-columns: 1fr 320px;
    grid-gap: 40px;
    align-items: start;
}

.is-tablet .voting {
    grid-gap: 10px;
}

.is-mobile .voting {
    grid-template-columns: 1fr;
    grid-gap: 10px;
    padding: 10px;
}

.voting.is-hidden {
	opacity: 0;
}

.voting-you {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
}

.voting-you-item {
    background-color: #4881bb;
    border-radius: 4px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    flex-direction: column;
}

.voting-you-item.is-green {
    background-color: #48bb6d;
}

.voting-you-item.is-red {
    background-color: #bb4848;
}

.voting-you-item.is-dark {
	background-color: #082534;
}

.voting-you-item-value {
    font-size: 48px;
    font-weight: 700;
}

.voting-you-item-label {
    font-size: 14px;
    margin-top: 4px;
    font-weight: 400;
}

.voting-you-item.is-dark .voting-you-item-value {
    font-size: 24px;
    text-align: center;
    font-weight: 500;
}

.voting-list {
    background-color: #fff;
    border-radius: 0px 4px 4px 4px;
    border: 1px solid #ddd;
    margin-top: 64px;
}

.voting-list >>> .tabs {
    margin-top: -64px;
    margin-left: -1px;
}

.voting-list >>> .tabs:after,
.voting-list >>> .tabs:before {
    display: none;
}

.voting-info {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 10px;
    align-content: start;
}

.voting-about {
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #fff;
    padding: 20px;
}

.is-mobile .voting-about {
    padding: 10px;
}

.is-mobile .voting-about.is-details {
    border: 0px;
}

.voting-about p {
	font-size: 16px;
	line-height: 20px;
	color: #222;
	margin-bottom: 20px;
}

.is-mobile .voting-about p {
    font-size: 14px;
    line-height: 18px;
}

.voting-about ul {
    list-style: disc;
    list-style-position: outside;
}

.voting-about li {
	font-size: 16px;
	line-height: 20px;
	color: #222;
	margin-bottom: 10px;
    margin-left: 20px;
}

.is-mobile .voting-about li {
    font-size: 14px;
    line-height: 18px;
}

.voting-about li:last-child {
    margin-bottom: 0px;
}

.voting-about p:last-child {
	margin-bottom: 0px;
}

.voting-row.is-head {
    background-color: #4881bb;
    border-radius: 4px 4px 0px 0px;
    color: #fff;
}

.voting-row.is-head .voting-cell {
    line-height: 40px;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    padding: 0px 20px;
}

.voting-list-empty {
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    padding: 40px;
    color: #333;
    font-weight: 300;
}

</style>